import type { CookieService, LocalStorageService } from "@packages/common";
import type { Config } from "@packages/config";

import { CONFIG } from "@packages/config";
import { Inject, Injectable } from "@webmotors/ioc";

import { COOKIE_SERVICE, LOCAL_STORAGE_SERVICE } from "@packages/common";
import { document } from "@packages/global";
import { COOKIE_CONSENTS_SERVICE } from "./cookie-consents.types";
import { CookieConsentsConfigDTO, CookieConsentsDTO } from "./dtos";

@Injectable(COOKIE_CONSENTS_SERVICE)
export class CookieConsentsService {
  constructor(
    @Inject(LOCAL_STORAGE_SERVICE)
    private readonly localStorageService: LocalStorageService,
    @Inject(COOKIE_SERVICE) private readonly cookieService: CookieService,
    @Inject(CONFIG) private readonly config: Config
  ) {}

  private async save(
    item: CookieConsentsConfigDTO
  ): Promise<CookieConsentsConfigDTO> {
    this.localStorageService.setItem(this.config.cookieNoticeName, item);
    return item;
  }

  async getCookieConsent(): Promise<CookieConsentsConfigDTO> {
    const item = this.localStorageService.getItem<CookieConsentsConfigDTO>(
      this.config.cookieNoticeName
    );

    if (item) {
      return item;
    }

    return this.save(
      new CookieConsentsConfigDTO({
        showCookieNotice: true,
        cookies: new CookieConsentsDTO({
          proposals: true,
          search: true,
          marketing: true,
          experience: true,
        }),
      })
    );
  }

  clearSearchCookies() {
    const searchCookies = ["WMLastFilterSearch", "WebMotorsLastSearches"];

    for (const cookieKey of searchCookies) {
      this.cookieService.removeCookie(cookieKey);
    }
  }

  async saveCookieConsent(item: CookieConsentsConfigDTO) {
    const config = await this.save(item);

    if (!config.cookies.search) {
      this.clearSearchCookies();
    }

    document.dispatchEvent(
      new CustomEvent("@CookieService:saveCookieConsent", {
        detail: config,
      })
    );

    return config;
  }

  async isSearchEnabled(): Promise<boolean> {
    const { cookies } = await this.getCookieConsent();
    return !!cookies?.search;
  }
}
